import React, { forwardRef } from 'react'
import WebinarRegistrationSelectUi from './uiNew/WebinarRegistrationSelectUi'

type WebinarRegistrationTimeOptionsProps = {
  value?: string
  options?: Record<string, string>
  handleChange: (val: string) => void
  dataTestId?: string
}

const WebinarRegistrationTimeOptions = forwardRef<
  HTMLSelectElement,
  WebinarRegistrationTimeOptionsProps
>(({ options, value, handleChange, dataTestId }, ref) => {
  const isServer = typeof window === 'undefined'
  return (
    <WebinarRegistrationSelectUi
      ref={ref}
      data-test-id={dataTestId}
      value={value}
      onChange={e => handleChange(e.target.value)}
    >
      {options &&
        !isServer &&
        Object.keys(options).map(key => (
          <option key={key} value={key}>
            {options[key]}
          </option>
        ))}
    </WebinarRegistrationSelectUi>
  )
})

export default WebinarRegistrationTimeOptions
